export const getMemberContact = member => ({
  customerName: member ? (member.customerName || [member.firstName, member.lastName].filter(Boolean).join(" ") || member.name || "") : "",
  phone: member ? String(member.phone || member.phoneNumber || "") : ""
});
